module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addmenu/addmenu.component.css
// module id = ./src/app/addmenu/addmenu.component.css
// module chunks = main